module.exports = __webpack_public_path__ + "img/shape-21.3208030b.svg";